import React, { useEffect, useMemo, useRef, useState } from "react";
import { getCurrentDate } from "../../Utilitie";
import { cards } from "./CASHelper";
import { FaIndustry } from "react-icons/fa";
import ActualLoadingTable from "./ActualLoadingTable";
import OverallLoadingTable from "./OverallLoadingTable";
import DownloadExcel from "../../Extra/DownloadExcel";
const ActualLoadingSummary = ({ data, date }) => {
  const tempData = data;
  const tableRef = useRef();
  const getColorCode = (obj) => {
    const sortedExp = [...(obj.exp_ready ?? [])].sort(
      (a, b) => new Date(b.exp_ready_date) - new Date(a.exp_ready_date),
    );

    const latestExpDate = sortedExp[0]?.exp_ready_date?.slice(0, 10);
    const oldestExpDate = sortedExp[
      sortedExp.length - 1
    ]?.exp_ready_date?.slice(0, 10);

    const readyDate = obj?.ready_date?.slice(0, 10);

    if (!latestExpDate) return "";

    if (!readyDate) {
      if (date.from > latestExpDate) {
        return "bg-custom-danger";
      }

      if (
        oldestExpDate &&
        oldestExpDate <= date.from &&
        date.from <= latestExpDate
      ) {
        return "bg-custom-danger";
      }
    } else {
      if (latestExpDate > readyDate && readyDate === date.from) {
        return "bg-custom-success";
      }

      if (oldestExpDate && readyDate > oldestExpDate) {
        return "bg-custom-danger";
      }
    }

    return "";
  };

  const finalData = useMemo(() => {
    return tempData.filter((obj) => getColorCode(obj) !== "bg-custom-danger");
  }, [tempData, date.from]);

  const cmtWagons = [
    ...new Set(
      data
        .filter((obj) => obj.commodity === "CEMT")
        .map((obj) => obj.wagon_type),
    ),
  ];

  const otherWagons = [
    ...new Set(
      data
        .filter((obj) => obj.commodity !== "CEMT")
        .map((obj) => obj.wagon_type),
    ),
  ];

  const initial = {
    totalCementRakes: 0,
    totalOtherRakes: 0,
    wagonTypeCount: {},
  };
  const total = finalData.reduce(
    (acc, item) => {
      const wagons = Number(item.loading_wagons || item.wagons || 0);
      const type = item.wagon_type;

      // Commodity Group
      const commodity =
        item.commodity === "CEMT"
          ? "CEMT"
          : item.commodity === "RMC"
            ? "RMC"
            : "OTHER";

      if (commodity === "CEMT") {
        // Overall totals
        acc.totalCementRakes += wagons;
        acc.totalCementWagonsType++;

        if (type) {
          acc.cement[type] = (acc.cement[type] || 0) + wagons;
          acc.cementCount[type] = (acc.cementCount[type] || 0) + 1;
        }
      } else if (commodity === "RMC") {
        // Overall totals
        acc.totalRMCRakes += wagons;
        acc.totalRMCWagonsType++;

        if (type) {
          acc.rmc[type] = (acc.rmc[type] || 0) + wagons;
          acc.rmcCount[type] = (acc.rmcCount[type] || 0) + 1;
        }
      } else {
        // Overall totals
        acc.totalOtherRakes += wagons;
        acc.totalOtherWagonsType++;

        if (type) {
          acc.other[type] = (acc.other[type] || 0) + wagons;
          acc.otherCount[type] = (acc.otherCount[type] || 0) + 1;
        }
      }

      // Overall grouped by commodity
      if (type) {
        acc.overall[commodity].wagon_type[type] =
          (acc.overall[commodity].wagon_type[type] || 0) + 1;

        acc.overall[commodity].rakes[type] =
          (acc.overall[commodity].rakes[type] || 0) + wagons;
      }

      return acc;
    },
    {
      // Overall totals
      totalCementRakes: 0,
      totalRMCRakes: 0,
      totalOtherRakes: 0,

      // Number of rakes
      totalCementWagonsType: 0,
      totalRMCWagonsType: 0,
      totalOtherWagonsType: 0,

      // Wagon totals by type
      cement: {},
      rmc: {},
      other: {},

      // Rake counts by type
      cementCount: {},
      rmcCount: {},
      otherCount: {},

      // Overall summary by commodity
      overall: {
        CEMT: {
          wagon_type: {},
          rakes: {},
        },
        RMC: {
          wagon_type: {},
          rakes: {},
        },
        OTHER: {
          wagon_type: {},
          rakes: {},
        },
      },
    },
  );

  const summary = data.reduce((acc, item) => {
    const commodity = item.commodity || "UNKNOWN";
    const wagonType = item.wagon_type || "UNKNOWN";
    const key = `${commodity}_${wagonType}`;

    if (!acc[key]) {
      acc[key] = {
        commodity,
        wagonType,
        count: 0,
        wagonCount: 0,
      };
    }

    acc[key].count += 1;
    acc[key].wagonCount += Number(item.loading_wagons || item.wagons || 0);

    return acc;
  }, {});

  const result = Object.values(summary);

  const grandTotal =
    (total.totalCementRakes || 0) +
    (total.totalRMCRakes || 0) +
    (total.totalOtherRakes || 0);

  const actCmtWagons = [
    ...new Set(
      finalData
        .filter((obj) => obj.commodity === "CEMT")
        .map((obj) => obj.wagon_type),
    ),
  ];

  const actOtherWagons = [
    ...new Set(
      finalData
        .filter((obj) => obj.commodity !== "CEMT")
        .map((obj) => obj.wagon_type),
    ),
  ];

  return (
    <div>
      <div className="newUiBody">
        <div className="row bg-dark text-white m-1">
          <h4> Actual Loading Summary </h4>
        </div>
        {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        {data.length > 0 ? (
          <div className="card border-0 shadow-lg rounded-4 overflow-hidden m-1">
            {/* Header */}
            <div
              className="px-4 py-3 text-white bg-dark"
              style={
                {
                  //   background: "linear-gradient(135deg,#1e3c72,#2a5298)",
                }
              }
            >
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="fw-bold mb-0">
                  <FaIndustry className="me-2" />
                  Over View
                </h4>

                <span className="badge bg-light text-dark fs-6 px-3 py-2 rounded-pill">
                  Total : {total.totalCementRakes + total.totalOtherRakes}
                </span>
              </div>
            </div>

            {/* Body */}
            <div className="card-body bg-light">
              <div className="row g-3">
                {cards.map((card) => (
                  <div className="col-lg-3" key={card.title}>
                    <div
                      className="card border-0 shadow rounded-4 h-100"
                      style={{
                        borderLeft: `6px solid ${card.border}`,
                        transition: ".3s",
                      }}
                    >
                      <div className="card-body d-flex align-items-center">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: 65,
                            height: 65,
                            background: card.bg,
                          }}
                        >
                          {card.icon}
                        </div>

                        <div className="ms-3">
                          <small className="text-muted text-uppercase fw-bold">
                            {card.title}
                          </small>

                          <h2 className="fw-bold mb-0">
                            {card.title === "Grand Total"
                              ? grandTotal
                              : total[card.value]}
                          </h2>

                          <small className={`text-${card.color}`}>
                            {card.isTotal
                              ? "Overall Loading"
                              : `${(
                                  ((total[card.value] || 0) /
                                    (grandTotal || 1)) *
                                  100
                                ).toFixed(2)} % of Total`}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="" ref={tableRef}>
              {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
              <div className="row bg-dark text-white pt-1 pb-1">
                <h5> Overall Loading Brake Down</h5>
              </div>
              <OverallLoadingTable data={result} />
              {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
              <div className="row bg-dark text-white pt-1 pb-1">
                <h5> Actual Loading Brake Down</h5>
              </div>
              <ActualLoadingTable
                cmtWagons={actCmtWagons}
                otherWagons={actOtherWagons}
                data={total}
              />

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>
                      <th>sr</th>
                      <th>Category</th>
                      <th>Wagons</th>
                      {[...new Set([...cmtWagons, ...otherWagons])].map(
                        (wagon, k) => {
                          return <th key={k}>{wagon}</th>;
                        },
                      )}{" "}
                      <th>Total</th>
                      <th>Unloading</th>
                    </tr>
                  </thead>

                  <tbody>
                    {[
                      "CEMT",
                      "OTHER THEN CEMT",
                      "TOTAL",
                      "Rev.RMC",
                      "G.T.",
                    ].map((head, h) => (
                      <tr key={h}>
                        <td>{h + 1}</td>
                        <td>{head}</td>

                        {/* Total Wagons */}
                        <td>
                          {head === "CEMT"
                            ? total.totalCementRakes
                            : head === "OTHER THEN CEMT"
                              ? total.totalOtherRakes
                              : head === "TOTAL"
                                ? total.totalCementRakes + total.totalOtherRakes
                                : head === "Rev.RMC"
                                  ? total.totalRMCRakes
                                  : total.totalCementRakes +
                                    total.totalOtherRakes +
                                    total.totalRMCRakes}
                        </td>

                        {[...new Set([...cmtWagons, ...otherWagons])].map(
                          (wagon, w) => {
                            const cemtWagons =
                              total?.overall?.CEMT?.wagon_type?.[wagon] || 0;
                            const otherWagons =
                              total?.overall?.OTHER?.wagon_type?.[wagon] || 0;
                            const rmcWagons =
                              total?.overall?.RMC?.wagon_type?.[wagon] || 0;

                            const cemtRakes =
                              total?.overall?.CEMT?.rakes?.[wagon] || 0;
                            const otherRakes =
                              total?.overall?.OTHER?.rakes?.[wagon] || 0;
                            const rmcRakes =
                              total?.overall?.RMC?.rakes?.[wagon] || 0;

                            const wagonValue =
                              head === "CEMT"
                                ? cemtWagons
                                : head === "OTHER THEN CEMT"
                                  ? otherWagons
                                  : head === "TOTAL"
                                    ? cemtWagons + otherWagons
                                    : head === "Rev.RMC"
                                      ? rmcWagons
                                      : cemtWagons + otherWagons + rmcWagons;

                            const rakeValue =
                              head === "CEMT"
                                ? cemtRakes
                                : head === "OTHER THEN CEMT"
                                  ? otherRakes
                                  : head === "TOTAL"
                                    ? cemtRakes + otherRakes
                                    : head === "Rev.RMC"
                                      ? rmcRakes
                                      : cemtRakes + otherRakes + rmcRakes;

                            return (
                              <td key={w}>
                                <div className="d-flex flex-column justify-content-center">
                                  <span
                                    className="text-dark fw-bold"
                                    style={{ fontSize: "13px", opacity: 0.8 }}
                                  >
                                    {wagonValue}
                                  </span>

                                  <span
                                    className="text-muted fw-semibold"
                                    style={{
                                      fontSize: "11px",
                                      letterSpacing: "0.5px",
                                    }}
                                  >
                                    {rakeValue}
                                  </span>
                                </div>
                              </td>
                            );
                          },
                        )}

                        <td>
                          <div className="d-flex flex-column justify-content-center">
                            <span
                              className="text-dark fw-bold"
                              style={{ fontSize: "13px", opacity: 0.8 }}
                            >
                              {head === "CEMT"
                                ? Object.values(
                                    total?.overall?.CEMT?.wagon_type || {},
                                  ).reduce((a, b) => a + b, 0)
                                : head === "OTHER THEN CEMT"
                                  ? Object.values(
                                      total?.overall?.OTHER?.wagon_type || {},
                                    ).reduce((a, b) => a + b, 0)
                                  : head === "TOTAL"
                                    ? Object.values(
                                        total?.overall?.CEMT?.wagon_type || {},
                                      ).reduce((a, b) => a + b, 0) +
                                      Object.values(
                                        total?.overall?.OTHER?.wagon_type || {},
                                      ).reduce((a, b) => a + b, 0)
                                    : head === "Rev.RMC"
                                      ? Object.values(
                                          total?.overall?.RMC?.wagon_type || {},
                                        ).reduce((a, b) => a + b, 0)
                                      : Object.values(
                                          total?.overall?.CEMT?.wagon_type ||
                                            {},
                                        ).reduce((a, b) => a + b, 0) +
                                        Object.values(
                                          total?.overall?.OTHER?.wagon_type ||
                                            {},
                                        ).reduce((a, b) => a + b, 0) +
                                        Object.values(
                                          total?.overall?.RMC?.wagon_type || {},
                                        ).reduce((a, b) => a + b, 0)}
                            </span>

                            <span
                              className="text-muted fw-semibold"
                              style={{
                                fontSize: "11px",
                                letterSpacing: "0.5px",
                              }}
                            >
                              {head === "CEMT"
                                ? Object.values(
                                    total?.overall?.CEMT?.rakes || {},
                                  ).reduce((a, b) => a + b, 0)
                                : head === "OTHER THEN CEMT"
                                  ? Object.values(
                                      total?.overall?.OTHER?.rakes || {},
                                    ).reduce((a, b) => a + b, 0)
                                  : head === "TOTAL"
                                    ? Object.values(
                                        total?.overall?.CEMT?.rakes || {},
                                      ).reduce((a, b) => a + b, 0) +
                                      Object.values(
                                        total?.overall?.OTHER?.rakes || {},
                                      ).reduce((a, b) => a + b, 0)
                                    : head === "Rev.RMC"
                                      ? Object.values(
                                          total?.overall?.RMC?.rakes || {},
                                        ).reduce((a, b) => a + b, 0)
                                      : Object.values(
                                          total?.overall?.CEMT?.rakes || {},
                                        ).reduce((a, b) => a + b, 0) +
                                        Object.values(
                                          total?.overall?.OTHER?.rakes || {},
                                        ).reduce((a, b) => a + b, 0) +
                                        Object.values(
                                          total?.overall?.RMC?.rakes || {},
                                        ).reduce((a, b) => a + b, 0)}
                            </span>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="m-1">
              <DownloadExcel
                tableRef={tableRef}
                fileName={`Actual Loading Report ${date.from}`}
              />
            </div>
          </div>
        ) : (
          "no data found"
        )}
      </div>
    </div>
  );
};
export default ActualLoadingSummary;
